/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { VStack, Heading, HStack } from 'chakra-v3';
import { Text } from '../Text';
import { Button } from '../buttons/Index';

interface VerificationPendingProps {
  onConfirm: () => void;
  onDeny: () => void;
  onEdit: () => void;
  isLoading: boolean;
  upiId?: string;
  name?: string;
}

export const VerificationPending: React.FC<VerificationPendingProps> = ({
  onConfirm,
  onDeny,
  onEdit,
  isLoading,
  upiId,
  name,
}) => {
  return (
    <VStack gap={4} align="start">
      <Heading as="h2">Verify Account</Heading>
      <VStack gap={2} align="start">
        <Text variant="body" color="text.primary">
          We have initiated a transfer of ₹2 to verify your account.
        </Text>
        <Text variant="body" color="text.primary">
          <Text as="span" fontWeight="600">
            UPI ID:
          </Text>{' '}
          {upiId}
        </Text>
        <Text variant="body" color="text.primary">
          <Text as="span" fontWeight="600">
            Name:
          </Text>{' '}
          {name}
        </Text>
      </VStack>

      <Text variant="body" color="text.primary">
        Did you receive the amount?
      </Text>

      <HStack gap={3} mt={2} flexWrap="wrap">
        <Button onClick={onConfirm} disabled={isLoading} variant="secondary">
          {isLoading ? 'Verifying...' : 'Yes, I received it'}
        </Button>

        <Button onClick={onDeny} disabled={isLoading} variant="secondary">
          Haven&apos;t received it?
        </Button>

        <Button onClick={onEdit} disabled={isLoading} variant="secondary">
          Edit Details
        </Button>
      </HStack>

      <Text variant="caption" color="text.primary" fontSize="sm">
        Note: You can only retry verification once per hour.
      </Text>
    </VStack>
  );
};
